module.exports = __webpack_public_path__ + "media/images/pepsi-coke--shared_origin-4315d851c6dc3eae2169dbb6cc793068.svg";